module.exports = __webpack_public_path__ + "static/img/img-12.fc0444c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-12.jpg
// module id = 95
// module chunks = 0